/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteStagedAltArtResponse } from '../../models/delete-staged-alt-art-response';

export interface AdminServiceDeleteStagedAltArt$Params {
  gachaId: string;
  altArtId: number;
}

export function adminServiceDeleteStagedAltArt(http: HttpClient, rootUrl: string, params: AdminServiceDeleteStagedAltArt$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteStagedAltArtResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceDeleteStagedAltArt.PATH, 'delete');
  if (params) {
    rb.path('gachaId', params.gachaId, {});
    rb.path('altArtId', params.altArtId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteStagedAltArtResponse>;
    })
  );
}

adminServiceDeleteStagedAltArt.PATH = '/api/v3/gateway/admin/stage/alt_art/{gachaId}/{altArtId}';
